import { render } from "./Designer.vue?vue&type=template&id=001d66dd&scoped=true"
import script from "./Designer.vue?vue&type=script&lang=js"
export * from "./Designer.vue?vue&type=script&lang=js"

import "./Designer.vue?vue&type=style&index=0&id=001d66dd&lang=scss&scoped=true"

import exportComponent from "/Users/arvindersingh/Desktop/projects/parsoftwares/rt-backend/backend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-001d66dd"]])

export default __exports__